import { useState, useEffect } from 'react';
import { environment } from '../components/Services/environment';

const endpoint = environment.serverUrl;

/**
 * Custom hook to check for app updates
 */
export const useAppUpdate = (storeUrl) => {
  const [showAppUpdate, setAppUpdate] = useState(false);

  useEffect(() => {
    if (!storeUrl) return;

    checkAppUpdate();
  }, [storeUrl]);

  const checkAppUpdate = () => {
    fetch(`${endpoint}/api/Store/app-update?storeUrl=${storeUrl}`)
      .then(response => {
        if (!response.ok) {
          return;
        }
        return response.json();
      })
      .then(data => {
        if (data === true) {
          setAppUpdate(true);
        }
      })
      .catch(error => {
        setAppUpdate(false);
      });
  };

  return showAppUpdate;
};
